import FlexLayout from "./FlexLayout";
import { diff_match_patch, DIFF_INSERT } from "diff-match-patch";

const dmp = new diff_match_patch();

const DetailsBox = ({
  heading,
  btnText,
  prevData,
  newData,
  fieldsData,
  onShowPopup,
}) => {

  const compareText = (prevText, curretText) => {
    const cleanText = (text) => {
      const str = text?.toString() || "";
      if (/<[a-z][\s\S]*>/i.test(str)) {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = str;
        return tempDiv.textContent || tempDiv.innerText || "";
      }
      return str;
    };

    let pText = cleanText(prevText);
    let cText = cleanText(curretText);

    // Heuristic: If strings contain commas, treat as CSV sets to avoid order-change highlighting
    if (pText.includes(',') || cText.includes(',')) {
      const sortCSV = (str) => {
        const parts = str.split(',').map(s => s.trim()).filter(s => s);
        return parts.length > 0 ? parts.sort().join(', ') : str;
      };
      pText = sortCSV(pText);
      cText = sortCSV(cText);
    }

    const diffs = dmp.diff_main(pText, cText);

    dmp.diff_cleanupSemantic(diffs);
    dmp.Diff_EditCost = 6;
    dmp.diff_cleanupEfficiency(diffs);

    const formatted = diffs
      .map(([type, text]) => {
        if (type === DIFF_INSERT) {
          return `<span style="font-weight: bold;">${text}</span>`;
        } else if (type === 0) {
          return text;
        } else {
          return "";
        }
      })
      .join("");

    return formatted;
  };



  return (
    <>
      <div style={{ padding: "0px 40px" }}>
        <FlexLayout
          col1={
            <>
              <div className="heading-text">{heading}</div>
            </>
          }
          col2={
            <>
              <div style={{ textAlign: "right" }}>
                <button
                  className="btn-outline-primary"
                  onClick={() => onShowPopup(newData)}
                >
                  {btnText}
                </button>
              </div>
            </>
          }
        />
        <div
          className="gray-box"
          style={{ marginTop: "10px", lineHeight: "27px", color: "#47515C" }}
        >
          {fieldsData.map(col => {
            const formatted = compareText(prevData[col.colKey], newData[col.colKey])
            const hilitedText = <span dangerouslySetInnerHTML={{ __html: formatted }}></span>
            if (col.printInNewLine) {
              return <>
                <div> {col.colText}: </div>
                <div style={{ marginLeft: "20px" }}>{hilitedText}</div>
              </>
            } else {
              return <>
                <div> {col.colText}: {hilitedText}</div>
              </>
            }
          }
          )}
        </div>
      </div>
    </>
  );
};

export default DetailsBox;
